<template>
  <card-item legend="Cadastro de Arrematantes" icon="user-friends" icon-type="fa">
    <div class="card-content min-pad">
      <div style="width: 100%" id="container-chart-cadastro-stats"></div>
    </div>
    <div class="diviser"></div>
    <div class="card-link-column">
      <card-item-link legend="Base total" :subtitle="total" icon-type="fa"/>
      <card-item-link legend="Aprovados" :subtitle="aprovados" icon-type="fa"/>
      <card-item-link legend="Análise" :subtitle="analise" icon-type="fa"/>
      <card-item-link legend="Sem Doc" :subtitle="semdoc" icon-type="fa"/>
    </div>
    <div class="diviser"></div>
    <a @click="$router.push({name: 'arrematantes.lista'})" class="card-btn">
      <u-icon name="arrow_forward"/>
      Acessar arrematantes
    </a>
  </card-item>
</template>

<script>
import CardItem from '@/reuse/card/Card'
import Highcharts from 'highcharts'
// import {date} from 'uloc-vue'
import CardItemLink from '@/reuse/card/CardItemLink'
import Mixin from './mixin'
import * as Status from '@/domain/arrematante/helpers/Status'

let meses = ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez']

export default {
  name: "CadastroStats",
  mixins: [Mixin],
  components: {CardItemLink, CardItem},
  data() {
    return {
      categories: [],
      series: [],
      aprovados: 0,
      analise: 0,
      semdoc: 0
    }
  },
  computed: {
    Status () {
      return Status
    },
    cadastros() {
      if (!this.basicData || !this.basicData.cadastrosArrematante) {
        return []
      }
      return this.basicData.cadastrosArrematante
    },
    status() {
      if (!this.basicData || !this.basicData.cadastrosArrematanteStatus.status) {
        return []
      }
      return this.basicData.cadastrosArrematanteStatus.status
    },
    total () {
      if (!this.status) return 0
      let total = 0
      this.status.map(c => {
        total += Number(c.count)
      })
      return this.$options.filters.number(total)
    }
  },
  watch: {
    cadastros (v) {
      if (!this.cadastros) return
      let acessos = Object.values(this.cadastros.acessos)
      // Ajusta somente no máximo os 12 últimos meses
      let anos = {}
      acessos.map(a => {
        if (typeof anos[a.year] === "undefined") {
          anos[a.year] = []
        }
        anos[a.year].push(a)
      })
      acessos = []
      for (let ano in anos) {
        anos[ano].sort(function(a, b) {
          return (Number(a['year'] + String(a['month']).length === 1 ? '0' : '' + a['month'])) - (Number(b['year'] + String(b['month']).length === 1 ? '0' : '' + a['month']));
        })
        acessos = acessos.concat(anos[ano])
      }
      if (acessos.length > 12) {
        acessos = acessos.slice(acessos.length - 12)
      }
      this.categories = acessos.map(v => meses[Number(v['month'])-1])
      this.series = acessos.map(v => Number(v['count']))
      this.aprovados = this.subtotal(Status.STATUS_APROVADO)
      this.analise = this.subtotal(Status.STATUS_EM_ANALISE)
      this.semdoc = this.subtotal(Status.STATUS_PENDENTE)
      this.$nextTick(() => {
        if (this.chart) {
          this.chart.series[0].setData(this.series)
          this.chart.xAxis[0].categories = this.categories;
          this.chart.xAxis[0].setCategories(this.categories)
          this.chart.redraw()
        }
      })
    }
  },
  mounted() {
    this.gerarGrafico()
  },
  methods: {
    gerarGrafico() {
      this.$nextTick(() => {
        let title = 'Acessos ao site e app'

        Highcharts.setOptions({
          lang: {
            thousandsSep: '.'
          }
        })

        this.chart = Highcharts.chart('container-chart-cadastro-stats', {

          chart: {
            height: 300
          },
          title: {
            text: null
          },

          yAxis: {
            title: {
              text: null
            }
          },

          xAxis: {
            accessibility: {
              // rangeDescription: 'Range: 2010 to 2017'
            },
            categories: this.categories
          },


          legend: {
            layout: 'vertical',
            align: 'right',
            verticalAlign: 'middle'
          },

          plotOptions: {
            line: {
              dataLabels: {
                enabled: true
              },
              enableMouseTracking: false
            }
          },

          series: [
            {
              name: 'Novos Cadastros',
              data: this.series
            }
          ],

          responsive: {
            rules: [{
              condition: {},
              chartOptions: {
                legend: {
                  layout: 'horizontal',
                  align: 'center',
                  verticalAlign: 'bottom'
                }
              }
            }]
          }

        })
      })
    },
    subtotal (s) {
      if (!this.status) return 0
      let total = 0
      this.status.filter(s1 => Number(s1.status) === Number(s)).map(c => {
        total += Number(c.count)
      })
      return this.$options.filters.number(total)
    }
  }
}
</script>
